import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import { useUpdated } from "@common/lib/hooks";
import * as React from "react";
import Content from "./Content";
import { type PackagePricing } from "./types";

import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode &
  PackagePricing.Ids & {
    blocksStyle: React.CSSProperties;
    contentStyle: React.CSSProperties;
    package: PackagePricing.Api.Package | null;
    tiers: PackagePricing.Api.Tiers | null;
    trial: PackagePricing.Api.Trial | null;
  };

export type ActionProps = {
  init: () => void;
};

export default (props: ActionProps & MapProps) => {
  useUpdated(() => {
    if (props.packageId || props.trialId) {
      props.init();
    }
  }, [props.packageId, props.trialId]);

  return (
    <Container {...getContainerProps(props)}>
      {!!props.package ? (
        <Content
          {...getRootContainerProps(props)}
          blocksStyle={props.blocksStyle}
          package={props.package}
          style={props.contentStyle}
          tiers={props.tiers!}
          trial={props.trial}
        />
      ) : props.isEditMode ? (
        <div>Please choose a package in the settings</div>
      ) : null}
    </Container>
  );
};
